import type { ReactNode, RefObject } from 'react';

import * as styles from './participant-overlay.css';

/** Shared searchable participants surface for moderation and document headers. */
export function ParticipantPanel({
  search,
  onSearchChange,
  searchRef,
  placeholder,
  children,
}: {
  search: string;
  onSearchChange: (value: string) => void;
  searchRef?: RefObject<HTMLInputElement | null>;
  placeholder: string;
  children: ReactNode;
}) {
  return (
    <>
      <div className={styles.searchBar}>
        <input
          ref={searchRef}
          className={styles.searchInput}
          aria-label={placeholder}
          placeholder={placeholder}
          value={search}
          onChange={event => onSearchChange(event.target.value)}
        />
      </div>
      <div className={styles.participantList}>{children}</div>
    </>
  );
}
